import { Link } from 'react-router-dom';

const stats = [
  { value: '15,000+', label: 'Patients Served' },
  { value: '25+', label: 'Medical Specialists' },
  { value: '15 Yrs', label: 'Years of Service' },
  { value: '6', label: 'Core Specialties' },
];

function renderAboutIcon(name) {
  const props = {
    width: 28,
    height: 28,
    strokeWidth: 2,
    stroke: 'var(--teal-primary)',
    fill: 'none',
    style: { display: 'block', flexShrink: 0 }
  };
  
  switch (name) {
    case 'mission':
      return (
        <svg viewBox="0 0 24 24" {...props} stroke="var(--gold-primary)">
          <circle cx="12" cy="12" r="10" />
          <circle cx="12" cy="12" r="6" />
          <circle cx="12" cy="12" r="2" />
        </svg>
      );
    case 'vision':
      return (
        <svg viewBox="0 0 24 24" {...props} stroke="var(--gold-primary)">
          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
          <circle cx="12" cy="12" r="3" />
        </svg>
      );
    case 'values':
      return (
        <svg viewBox="0 0 24 24" {...props} stroke="var(--gold-primary)">
          <polygon points="6 2 18 2 22 8 12 22 2 8 6 2" />
        </svg>
      );
    case 'Compassion':
      return (
        <svg viewBox="0 0 24 24" {...props}>
          <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
        </svg>
      );
    case 'Integrity':
      return (
        <svg viewBox="0 0 24 24" {...props}>
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
        </svg>
      );
    case 'Excellence':
      return (
        <svg viewBox="0 0 24 24" {...props}>
          <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
        </svg>
      );
    case 'Accessibility':
      return (
        <svg viewBox="0 0 24 24" {...props}>
          <circle cx="12" cy="12" r="10" />
          <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
          <line x1="2" y1="12" x2="22" y2="12" />
        </svg>
      );
    case 'Collaboration':
      return (
        <svg viewBox="0 0 24 24" {...props}>
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
      );
    case 'Continuous Learning':
      return (
        <svg viewBox="0 0 24 24" {...props}>
          <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
          <polyline points="17 6 23 6 23 12" />
        </svg>
      );
    case 'Experienced Team':
      return (
        <svg viewBox="0 0 24 24" {...props} stroke="var(--gold-primary)">
          <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
      );
    case 'Quality Standards':
      return (
        <svg viewBox="0 0 24 24" {...props} stroke="var(--gold-primary)">
          <polyline points="20 6 9 17 4 12" />
        </svg>
      );
    case 'Care When Needed':
      return (
        <svg viewBox="0 0 24 24" {...props} stroke="var(--gold-primary)">
          <circle cx="12" cy="12" r="10" />
          <polyline points="12 6 12 12 16 14" />
        </svg>
      );
    case 'Compassionate Care':
      return (
        <svg viewBox="0 0 24 24" {...props} stroke="var(--gold-primary)">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
        </svg>
      );
    default:
      return null;
  }
}

const valuesPractice = [
  { name: 'Compassion', desc: 'We treat every patient with empathy, dignity, and genuine care — as we would a member of our own family.' },
  { name: 'Integrity', desc: 'We are honest, transparent, and ethical in our diagnosis, treatment, and billing — always.' },
  { name: 'Excellence', desc: 'We hold ourselves to the highest clinical standards and continuously invest in training, technology, and quality improvement.' },
  { name: 'Accessibility', desc: 'Quality healthcare should not be a privilege. We offer affordable services and flexible options to all.' },
  { name: 'Collaboration', desc: 'Our specialists work as a unified team, ensuring patients receive holistic, coordinated care across disciplines.' },
  { name: 'Continuous Learning', desc: 'We never stop learning. From clinical research to patient feedback, we use every opportunity to get better.' }
];

const whyChooseUs = [
  { title: 'Experienced Team', desc: 'Internationally trained consultants and highly qualified nursing staff.' },
  { title: 'Quality Standards', desc: 'ISO-certified pathology laboratory and advanced imaging center.' },
  { title: 'Care When Needed', desc: 'Prompt appointments, minimal wait times, and emergency support.' },
  { title: 'Compassionate Care', desc: 'Dedicated focus on patient comfort, clear explanation of health issues, and ethical practices.' }
];

function About() {
  return (
    <>
      {/* Page Hero */}
      <section className="page-hero" style={{ backgroundImage: 'linear-gradient(rgba(8, 50, 62, 0.85), rgba(8, 50, 62, 0.85)), url(/images/hero_about.png)', backgroundSize: 'cover', backgroundPosition: 'center' }}>
        <div className="container">
          <div className="eyebrow" style={{ color: 'var(--gold-light)' }}>Who We Are</div>
          <h1>About Mega Health Group <br/><span style={{ fontSize: '1.5rem', fontWeight: 'normal' }}>(Mega Hospital Foundation)</span></h1>
          <p>A story of compassion, clinical excellence, and dedication to community health since 2022.</p>
          <div className="breadcrumb">
            <Link to="/">Home</Link>
            <span className="sep">›</span>
            <span className="current">About Us</span>
          </div>
        </div>
      </section>

      {/* Company Introduction */}
      <section className="section-pad" style={{ background: 'var(--white)' }}>
        <div className="container">
          <div className="grid-2">
            <div>
              <div className="eyebrow">Our Story</div>
              <h2>Building Healthier Communities, One Patient at a Time</h2>
              <p style={{ marginTop: '16px' }}>
                Mega Health Group (Mega Hospital Foundation) was established in 2022 by a team of visionary physicians who shared a common mission: to make high-quality healthcare accessible and affordable for everyone, regardless of their economic background. What began as a modest outpatient healthcare facility has grown into a comprehensive multi-specialty healthcare center, serving thousands of patients each year with excellence and compassion.
              </p>
              <p>
                Our hospital brings together experienced specialists in Ophthalmology (Eye Care), Maternity & Gynecology, Pediatrics, ENT, Dental Care, and Cosmetic Gynecology, supported by a state-of-the-art diagnostic laboratory and advanced ultrasound imaging services. Every aspect of our healthcare delivery is designed with a strong focus on patient comfort, safety, privacy, and overall well-being.
              </p>
              <p>
                In addition to our hospital services, we operate a network of pathology and diagnostic centers under the trade name Mega Lab & Digno Research Center. Through these centers, we provide reliable, accurate, and affordable laboratory and diagnostic services across multiple locations. Our vision is to extend quality healthcare services beyond urban areas by making essential medical facilities available in villages and rural communities as well.
              </p>
              <p>
                Community service is at the heart of our mission. We regularly organize free health camps, medical awareness programs, educational workshops, blood donation drives, and public health campaigns to promote preventive healthcare and healthy living. We also provide charitable medical services to financially disadvantaged patients, ensuring that no one is denied quality healthcare due to financial hardship.
              </p>
              <p>
                At Mega Health Group (Mega Hospital Foundation), we believe that healthcare is more than treating illness—it is about building healthier communities through compassion, accessibility, education, and service. Our commitment is to deliver trusted, affordable, and patient-centered healthcare to every individual, whether they live in a city, town, or remote village.
              </p>
              <Link to="/contact" className="btn btn-primary" style={{ marginTop: 12 }}>Book Your Visit</Link>
            </div>
            <img src="/images/clinic_main.png" alt="Mega Health Group Facility" style={{ width: '100%', aspectRatio: '4/3', objectFit: 'cover', borderRadius: 'var(--radius-lg)', boxShadow: 'var(--shadow-sm)' }} />
          </div>
        </div>
      </section>

      {/* Team Stats */}
      <section className="section-pad-sm" style={{ background: 'var(--teal-primary)' }}>
        <div className="container">
          <div className="grid-4" style={{ textAlign: 'center' }}>
            {stats.map(stat => (
              <div key={stat.label} style={{ background: 'rgba(255,255,255,0.08)', padding: '24px', borderRadius: 'var(--radius)' }}>
                <div style={{ fontSize: '2.5rem', fontWeight: 700, color: 'var(--gold-light)', fontFamily: 'Playfair Display, serif', marginBottom: 4 }}>
                  {stat.value}
                </div>
                <div style={{ fontSize: '0.8rem', textTransform: 'uppercase', letterSpacing: '0.08em', color: 'rgba(255,255,255,0.8)', fontWeight: 600 }}>
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Mission, Vision, Values */}
      <section className="section-pad" style={{ background: 'var(--bg-light)' }}>
        <div className="container">
          <div className="section-header center">
            <div className="eyebrow">Our Purpose</div>
            <h2>Mission, Vision & Values</h2>
          </div>
          
          <div className="mission-grid">
            <div className="mission-card">
              <div className="mc-icon" style={{ display: 'grid', placeItems: 'center', background: 'transparent' }}>{renderAboutIcon('mission')}</div>
              <h3>Our Mission</h3>
              <p style={{ fontSize: '0.95rem', lineHeight: 1.6, color: 'var(--muted)', marginBottom: 0 }}>
                To deliver exceptional, patient-centered healthcare that is accessible, compassionate, and continuously improving — empowering every individual we serve to live a healthier, fuller life.
              </p>
            </div>
            
            <div className="mission-card">
              <div className="mc-icon" style={{ display: 'grid', placeItems: 'center', background: 'transparent' }}>{renderAboutIcon('vision')}</div>
              <h3>Our Vision</h3>
              <p style={{ fontSize: '0.95rem', lineHeight: 1.6, color: 'var(--muted)', marginBottom: 0 }}>
                To be the most trusted healthcare group in the region — known for clinical excellence, ethical practice, and genuine community impact across every specialty we offer.
              </p>
            </div>
            
            <div className="mission-card">
              <div className="mc-icon" style={{ display: 'grid', placeItems: 'center', background: 'transparent' }}>{renderAboutIcon('values')}</div>
              <h3>Core Values</h3>
              <p style={{ fontSize: '0.95rem', lineHeight: 1.6, color: 'var(--muted)', marginBottom: 0 }}>
                Compassion, Integrity, Excellence, Accessibility, Collaboration, and Continuous Improvement guide every interaction we have — with patients and with each other.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Core Values in Practice */}
      <section className="section-pad" style={{ background: 'var(--white)' }}>
        <div className="container">
          <div className="section-header center">
            <div className="eyebrow">What We Stand For</div>
            <h2>Our Core Values in Practice</h2>
            <p>These principles shape how we recruit, how we treat, and how we grow.</p>
          </div>
          
          <div className="values-list">
            {valuesPractice.map(val => (
              <div key={val.name} className="value-item">
                <div className="value-icon" style={{ background: 'var(--teal-soft)', padding: 12, borderRadius: '50%', display: 'grid', placeItems: 'center' }}>
                  {renderAboutIcon(val.name)}
                </div>
                <div>
                  <h4>{val.name}</h4>
                  <p style={{ fontSize: '0.88rem', color: 'var(--muted)', marginBottom: 0 }}>{val.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Mega Health Group */}
      <section className="section-pad" style={{ background: 'var(--bg-light)' }}>
        <div className="container">
          <div className="section-header center">
            <div className="eyebrow">The Mega Difference</div>
            <h2>Why Choose Mega Health Group</h2>
            <p>We know you have choices. Here is what makes us worth trusting with your most important asset — your health.</p>
          </div>
          
          <div className="grid-2">
            <div className="grid-2" style={{ gap: 24 }}>
              {whyChooseUs.map(item => (
                <div key={item.title} className="card" style={{ padding: 24 }}>
                  <div style={{ marginBottom: 12 }}>{renderAboutIcon(item.title)}</div>
                  <h4 style={{ fontSize: '1.1rem', marginBottom: 6 }}>{item.title}</h4>
                  <p style={{ fontSize: '0.85rem', color: 'var(--muted)', marginBottom: 0, lineHeight: 1.5 }}>{item.desc}</p>
                </div>
              ))}
            </div>
            <div style={{ paddingLeft: 20 }}>
              <h3>A Higher Standard of Care</h3>
              <p style={{ marginTop: 16 }}>
                Our clinics are fully integrated, allowing for seamless coordination between ophthalmologists, gynecologists, pediatricians, ENT specialists, and dentists. This means you do not have to shuttle between different clinics to get comprehensive evaluations.
              </p>
              <p>
                Moreover, our in-house lab and ultrasound services deliver rapid, certified results directly to your doctor, minimizing delays in starting your treatment. We follow rigorous sanitation protocols and maintain absolute patient confidentiality.
              </p>
              <div style={{ marginTop: 24 }}>
                <Link to="/services" className="btn btn-primary">Our Specialties</Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default About;
